export default function MemberSettingsCtrl($scope, themePref) {
  $scope.appearance = themePref.getPreference();

  $scope.setAppearance = function (mode) {
    $scope.appearance = mode;
    themePref.setPreference(mode);
  };
}
